import api from "./api";


export const getOutletOutOfStocks = async (outlet_id) => {
    try{
        const response = await api.get(`/out_of_stock/get_out_of_stock_items/${outlet_id}`)
        return response.data.data

    }
    catch(error){

        throw new Error(error?.response?.data?.data)

    }
}


export const saveOutOfStockData = async (outlet_id,stockData) => {
    try{
        const response = await api.post(`/out_of_stock/save_out_of_stock/${outlet_id}`,stockData)
        return response.data

    }
    catch(error){

        throw new Error(error?.response?.data?.data)

    }
}